import axios from 'axios';
import { axiosSearchAiOptimizationAPI } from './endpoints';

const BASE_URL = axiosSearchAiOptimizationAPI;

const axiosSearchAiOptimization = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

export default axiosSearchAiOptimization;
